import React, { FC } from 'react';
import './UserProfile.css';
import { ActionStatusHelper, Alert, ConfirmModal, FaEdit, FaSignOutAlt, FaUser, FeedBackType, IoClose, MessageHelper, Modal, PageLoader, Toast, useAlert, useAppNavigation, useLightBox, useModal } from '@/Shared';
import { useUserProfile } from '../../Logic';
import PasswordForm from '../PasswordForm/PasswordForm';
import { useToast } from '@/Shared/Logic/Hooks/TechnicalHooks/useToast';
import { useConfirm } from '@/Shared/Logic/Hooks/TechnicalHooks/useConfirm';
import CloseButton from '@/Shared/UI/Components/Buttons/CloseButton/CloseButton';

interface UserProfileProps {
	onClose: () => void
}

const UserProfile: FC<UserProfileProps> = ({ onClose }) => {

	const modalHook = useModal();
	const toastHook = useToast();
	const confirmHook = useConfirm();
	const alertHook = useAlert();
	const lightBoxHook = useLightBox();

	const { response, viewModel } = useUserProfile({
		modalHook,
		toastHook,
		confirmHook,
		alertHook,
		lightBoxHook
	});

	const { goToLogOut } = useAppNavigation();

	const { isLoading, isFailed } = ActionStatusHelper.is(response.status);


	if (isFailed) {
		return (<Alert
			data={{
				message: response.error || MessageHelper.FETCHING.ERROR('Agent'),
				type: FeedBackType.ERROR
			}}
		/>);
	}

	if (isLoading || !viewModel) {
		return <PageLoader message={MessageHelper.FETCHING.LOADING('Agent')} />
	}

	return (
		<div className="UserProfile" data-testid="UserProfile">
			{/* Global toast notifications */}
			<Toast
				data={toastHook.toastData}
				onClose={toastHook.closeToast}
			/>

			{/* Global confirmation modal */}
			<ConfirmModal
				data={confirmHook.confirmData}
				onConfirm={confirmHook.confirm}
				onCancel={confirmHook.cancel}
			/>

			{/* Generic modal container (forms, details, etc.) */}
			<Modal
				className=''
				onClose={modalHook.closeModal}
				data={modalHook.modalData}
			/>

			<div className="UserProfile-header">
				<CloseButton onClick={onClose} />
				<FaUser className="UserProfile_avatar" />
			</div>

			<div className="UserProfile-body">
				<div className="UserProfile_name">{viewModel.fullName}</div>
				<div className="positions-role_wrapper flex-col">
					<div className="UserProfile_positions"><span className='positions_label'>Fonctions :</span> {viewModel.positions}</div>
					<div className="UserProfile_role"><span className='role_label'>Rôle :</span> {viewModel.role}</div>
				</div>

				<div className="UserProfile_buttons">
					<button
						className="UserProfile__button update"
						onClick={
							() => {
								modalHook.openModal({
									title: "Mot de Passe",
									content: <PasswordForm />
								})
							}
						}
					>
						<span className='with-icon'><FaEdit /> Mot de passe</span>
					</button>

					<button
						className="UserProfile__button logout"
						onClick={goToLogOut}
					>
						<FaSignOutAlt /> Déconnexion
					</button>
				</div>
			</div>
		</div>
	);
}

export default UserProfile;